<template>
  <Takeover active>
    <CheckoutHeader />
    <CheckoutContent />
    <UniversalModal />
  </Takeover>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import Takeover from '@/components/shared/Takeover.vue'
import CheckoutHeader from '@/components/shared/header/CheckoutHeader.vue'
import CheckoutContent from '@/components/shared/CheckoutContent.vue'
import UniversalModal from '@/components/shared/UniversalModal.vue'
import { useHead } from '@unhead/vue'
import { useHotKeyStore } from '@/store/HotKeyStore'
import { useProductStore } from '@/store/ProductStore'
import { storeToRefs } from 'pinia'

const { keyUpEventListener } = useHotKeyStore()
const productStore = useProductStore()
const { productName } = storeToRefs(productStore)

useHead({
  title: () => `Get ${productName.value} - Output`
})

onMounted(() => {
  eventListeners()
})

const eventListeners = () => {
  window.addEventListener('keyup', event => keyUpEventListener(event), false)
}
</script>
